import {stringifyId} from '../types'
import type {Permission, ProjectId} from '../types'

export const getProjectPermissionsLocator = (permission: Permission, projectId: ProjectId) =>
  `id:${stringifyId(projectId)},userPermission:(permission:${permission},user:current)`
